import React from 'react';
import store from "../../store";
import { unmountComponentAtNode, render} from 'react-dom'
import { Provider } from 'react-redux';

// This is a 'portal' which allows us to place components on the root of the
// body node.
// To use it, wrap a component in a <MountComponentOnBody> with a componentId:
// <MountComponentOnBody componentId="foo"><ModalPopup /></MountComponentOnBody>
const MountComponentOnBody = React.createClass({
  render: () => null,
  portalElement: null,
  componentDidMount() {
    let p = this.props.componentId && document.getElementById(this.props.componentId);
    if (!p) {
      p = document.createElement('div');
      p.id = this.props.componentId;
      document.body.appendChild(p);
    }
    this.portalElement = p;
    this.componentDidUpdate();
  },
  componentWillUnmount() {
    unmountComponentAtNode(this.portalElement);
  },
  componentDidUpdate() {
    render(
      <Provider store={store}>
        {this.props.children}
      </Provider>, this.portalElement
    );
  }
});

export default MountComponentOnBody;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/common/components/mount-component-on-body.es6